import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { formatPrice } from '../../utils/numberFormatter';
import { RowItems } from '../../models/TableProps';
import { InvoiceDetailsData } from '../../models/Invoice';

export const InvoiceProductsTableRow: React.FC<RowItems<InvoiceDetailsData>> = (
    props
) => {
    const { row, index } = props;
    const { t } = useTranslation('invoices', {
        keyPrefix: 'INVOICE_DETAILS',
    });
    const labelId = `enhanced-table-checkbox-${index}`;

    return (
        <TableRow
            role="checkbox"
            tabIndex={-1}
            hover key={labelId}>
            <TableCell padding="checkbox">
                {/*<Checkbox*/}
                {/*    color="primary"*/}
                {/*    checked={isItemSelected}*/}
                {/*    inputProps={{*/}
                {/*        'aria-labelledby': labelId,*/}
                {/*    }}*/}
                {/*    onClick={(event) =>*/}
                {/*        clickHandle(event, row.invoiceNumber.toString())*/}
                {/*    }*/}
                {/*/>*/}
            </TableCell>
            <TableCell id={labelId}>{row.lineObjectNumber}</TableCell>
            <TableCell>{row.description}</TableCell>
            <TableCell>
                {row.quantity} {t('QUANTITY_UNITS')}
            </TableCell>
            <TableCell>{formatPrice(row.unitPrice)} Ft</TableCell>
            <TableCell>{formatPrice(row.netAmount)} Ft</TableCell>
            <TableCell>{formatPrice(row.netAmountIncludingTax)} Ft</TableCell>
        </TableRow>
    );
};
